var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElectronicMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Concert-Dj--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Concert Dj Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23.94 22.09 -1.43 -5A1.5 1.5 0 0 0 21.07 16H2.93a1.5 1.5 0 0 0 -1.44 1.09l-1.43 5A1.5 1.5 0 0 0 1.5 24h21a1.5 1.5 0 0 0 1.44 -1.91ZM7 22c-1.68 0 -3 -0.88 -3 -2s1.32 -2 3 -2 3 0.88 3 2 -1.31 2 -3 2Zm10 0c-1.68 0 -3 -0.88 -3 -2s1.32 -2 3 -2 3 0.88 3 2 -1.32 2 -3 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7a3 3 0 1 0 6 0 3 3 0 1 0 -6 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.69 14.5a0.51 0.51 0 0 0 0.45 -0.73 5.67 5.67 0 0 0 -10.28 0 0.51 0.51 0 0 0 0.45 0.73Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.18 4.34a0.47 0.47 0 0 1 -0.33 -0.3A6.25 6.25 0 0 0 6.16 4a0.53 0.53 0 0 1 -0.34 0.31 2.5 2.5 0 0 0 0.64 4.91h1a0.5 0.5 0 0 0 0.5 -0.5V5a1.09 1.09 0 0 1 0.08 -0.39 4.25 4.25 0 0 1 7.84 0A1.09 1.09 0 0 1 16 5v3.75a0.5 0.5 0 0 0 0.5 0.5h1a2.5 2.5 0 0 0 0.68 -4.91Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgElectronicMusic);
export default ForwardRef;